
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing",
      function () {
        return require("private-next-pages/landing.page.tsx");
      }
    ]);
  